import { render, staticRenderFns } from "./EditSitucontratoPage.vue?vue&type=template&id=6192d433&"
import script from "./EditSitucontratoPage.vue?vue&type=script&lang=js&"
export * from "./EditSitucontratoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports